var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilledAlertTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#1B8728"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.295 7.605l-4.568 6c-.188.247-.479.393-.789.395h-.007c-.307 0-.597-.142-.787-.384l-2.432-3.107c-.34-.434-.264-1.063.171-1.403.434-.341 1.064-.265 1.404.171l1.633 2.086 3.784-4.969c.334-.439.961-.525 1.402-.19.439.335.524.962.189 1.401M0 10c0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10S0 4.477 0 10z",
    transform: "translate(-1232 -601) translate(1208 591) translate(24 10.5)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilledAlertTick);
export default __webpack_public_path__ + "static/media/icon-filled-alert-tick.26dcfeeccf9d37edf6355e98df9c7699.svg";
export { ForwardRef as ReactComponent };